import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-consignment-plans-delivery-driver',
  templateUrl: './consignment-plans-delivery-driver.component.html',
  styleUrls: ['./consignment-plans-delivery-driver.component.css']
})
export class ConsignmentPlansDeliveryDriverComponent implements OnInit {
    argType;

    argValue;

    public edit?: Edit;

    public selectListDeliveryMethods: DeliveryMethodItem[] = [];

    public updating = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue) {
            const editData = (await this.datatask.Post(1716, {
                argtype: this.argType,
                argvalue: this.argValue
            }));

            this.edit = editData;
            this.edit!.phone = editData.phone.replace(': ', '');
        }
    }

    private async loadDeliveryMethods() {
        this.selectListDeliveryMethods = await this.datatask.Post(1693);
    }

    public searchEquipmentNames = () => {
        return this.typeahead.searchEquipments(this.edit!.equipment_name);
    }

    public onEquipmentNameSelected(event?: Item) {
        if (!this.edit) return;

        this.edit.equipment_id = !!event ? '' + event.item_id : '0';
        this.edit.equipment_name = event?.item_name ?? '';
    }

    public async updateChanges() {
        if (!!this.edit) {
            try {
                this.updating = true;

                const response = (await this.datatask.Post(1717, {
                    argtype: this.argType,
                    argvalue: this.argValue,
                    deliverymethod_no: this.edit.deliverymethod_no,
                    delivery_phone: this.edit.phone,
                    equipment_id: this.edit.equipment_id
                }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.updating = false;
            }
        }
    }

    public onChanged(value: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'deliverymethod_no':
                this.selectListDeliveryMethods.forEach((item: any) => {
                    if (item.deliverymethod_no === value) {
                        this.edit!.phone = item.phone;
                    }
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadDeliveryMethods();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    error_code: string;
    error_message: string;
    deliverymethod_no: string;
    phone: string;
    equipment_id: string;
    equipment_name: string;
}

interface DeliveryMethodItem {
    deliverymethod_no: string;
    deliverymethod_name: string;
    phone: string;
    orderby: number;
}
